import React, { Component } from "react";
// import { render } from "react-dom";
import { Link } from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";
import axios from 'axios';
import imageCompression from 'browser-image-compression';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";


import './NewReturnOrder.scss';
import MyContext from '../MyContext.jsx';
import { epochToDate } from '../../assets/js/handy.mjs';

class NewReturnOrder extends Component {
  url = `${process.env.REACT_APP_SSS}/images/`;
  constructor(props) {
    super(props);
    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.state = {
      salesreturn_id: '',
      customers: [],
      customer: {},
      products: [],
      return_types: [],
      return_type: {},
      return_reason: '',
      rows: [{
        product: {},
        qty: '',
        unit_price: '',
        units: [],
        unit: {},
        total: '',
      }],
      grand_total: '',
      image : '',
      file : '',
      return_image : '',
      compress_image:'',
      fileDeleted:0,
      isOpen: false,
      keyboardSpacerHeight: 0,
    }
    this.customerSelect = React.createRef();
    this.return_typeSelect = React.createRef();
    this.productRowRefs = [];
    this.expandRowAndScroll = this.expandRowAndScroll.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    // this.formChange = this.formChange.bind(this);
    // this.onCheckboxChange = this.onCheckboxChange.bind(this);
    // this.ReturnTypeChange = this.ReturnTypeChange.bind(this);
    // this.deliveryTypeChange = this.deliveryTypeChange.bind(this);

  }

  componentDidMount() {
    $(".react-date-picker__inputGroup input").attr("readonly", "true");
    const { pathname } = this.props.location;
    if (pathname === "/salesreturn/new") {
      const url = `${process.env.REACT_APP_SSS}/api/exeSaleReturnDetails`;
      this.context.loading(1);
      var obj_this = this;
      $.ajax({
        url: url,
        data: {
          sid: this.context.user_details.sid
        },
        type: "POST"
      }).done(function (return_data) {
        console.log(return_data);
        if (return_data.status == "success") {
          // const products = return_data.products.filter((item) => item.units.length);
          obj_this.setState({
            customers: return_data.customers,
            products: return_data.products,
            return_types: return_data.return_types,
            rows: [{
              product: {},
              unit_price: '',
              qty: '',
              units: [],
              unit: {},
              total: '',
            }]
          }, () => {
            $(".new_returnorder_container").css("visibility", "visible");
          });
          obj_this.context.loading(0);
        } else {
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function () {
        alert("Network Error");
      });
    }
    else{
      const salesreturn_id = this.props.match.params.sale_return_id;
      const url = `${process.env.REACT_APP_SSS}/api/editSalesReturnorder`;
      this.context.loading(1);
      var obj_this = this;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          salesreturn_id : salesreturn_id
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          var state_object = return_data.state_object;
          state_object.products = state_object.products.filter((item) => item.units.length);
          obj_this.setState(state_object,() => {
            $(".minimize_button").trigger("click");
            $(".new_returnorder_container").css("visibility","visible");
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network ERror");
      });
    }

    var overflowTimeout = setTimeout(() => { });
    $(".products_container").on("click", ".maximize_button", function () {
      var elem = $(this).parents(".single_product_container");
      elem.find(".qty_unit_price_container").css("display", "none");
      elem.heightAuto().find(".minimize_button").css("display", "block");
      $(this).css("display", "none");
      overflowTimeout = setTimeout(function () {
        elem.css("overflow", "");
      }, 1000);
    });

    $(".products_container").on("click", ".minimize_button", function () {
      var elem = $(this).parents(".single_product_container");
      elem.find(".qty_unit_price_container").css("display", "grid");
      clearTimeout(overflowTimeout);
      var original_height = elem.height();//form submit react sending only required data
      elem.height(original_height);
      setTimeout(function () {
        elem.css({
          "height": "46px",
          "overflow": "hidden"
        }).find(".maximize_button").css("display", "block");
      }, 1);
      $(this).css("display", "none");
    });
  }

  customerChange(option) {
    // console.log(option);
    var obj_this = this;
    obj_this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/getCustomerDetails`;
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid,
        customer_id: option.value,
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        obj_this.setState({
          customer: option,
        });
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network ERRor");
    });
  }

  ReturnTypeChange(option) {
    if(!option){
      return
    }
    this.setState({
      return_type: option,
    });

  }
  formChange(e) {
    this.setState({
      return_reason: e.target.value
    });
  }
  onOrderDateChange(value) {
    // console.log(value);
    this.setState({ order_date: value });
  }

  onDeliveryDateChange(value) {
    // alert(value);
    this.setState({ delivery_date: value });
  }

  locationChange(option) {
    this.setState({ delivery_location: option })
  }

  productChange(option, idx) {
    // console.log(option);
    if(!this.state.customer.value)
    {
      this.customerSelect.current.focus();
      return
    }
    $(".single_product_container").css('background-color', '');
    const rows = [...this.state.rows];

    const row = { ...rows[idx] }
    row.unit_price = '';
    row.qty = '';
    row.unit = {};
    row.product = {};
    var obj_this = this;
    obj_this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/getProductUnits`;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        product_id : option.value,
        customer_id : this.state.customer.value
      },
      type : "POST"
    }).done(function(return_data){
      if(return_data.status == "success"){
          console.log(return_data);
          if(return_data.base_price && return_data.base_price.total ==null){
            alert('Please set MRP in Product Master');
            obj_this.context.loading(0)
            return;
          }
          
          let isSingleUnit = false;
          const rawUnits = return_data.units;
          if (Array.isArray(rawUnits)) {
            row.units = rawUnits;
            if (rawUnits.length === 1) {
              row.unit = rawUnits[0];
              isSingleUnit = true;
            } else {
              row.unit = {};
            }
          } else if (rawUnits && typeof rawUnits === 'object') {
            row.unit = rawUnits;
            row.units = [rawUnits];
            isSingleUnit = true;
          } else {
            row.unit = {};
            row.units = [];
          }
          
          const productLabel = option.label;
          const selectedUnitLabel = row.unit ? row.unit.label : '';
          if (selectedUnitLabel) {
            const isDuplicate = rows.some((item, i) => 
              i !== idx && 
              item.product && item.product.label === productLabel && 
              item.unit && item.unit.label === selectedUnitLabel
            );
            if (isDuplicate) {
              alert((productLabel ? productLabel + " with " : "") + selectedUnitLabel + " already added.");
              obj_this.context.loading(0);
              return;
            }
          }
          
          row.unit_price = return_data.base_price.total;
          rows[idx] = row;
          row.product = option;
        
        obj_this.setState({
          rows
        }, () => {
          setTimeout(() => {
            const $container = $(obj_this.productRowRefs[idx]);
            if ($container.length) {
              if (isSingleUnit) {
                const qtyInput = $container.find('.product_qty');
                if (qtyInput.length) {
                  qtyInput.focus();
                }
              } else {
                const unitInput = $container.find('.unit input');
                if (unitInput.length) {
                  unitInput.focus();
                }
              }
            }
          }, 100);
        });
        obj_this.context.loading(0)
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  unitChange(option, idx) {
    // console.log(option);
    $(".single_product_container").css('background-color', '');
    // if(!option.total){
    //   alert("Unit price is not added");
    //   return;
    // }
    const rows = [...this.state.rows];
    
    const productLabel = rows[idx].product ? rows[idx].product.label : '';
    const isDuplicate = rows.some((item, i) => 
      i !== idx && 
      item.product && item.product.label === productLabel && 
      item.unit && item.unit.label === option.label
    );
    if (isDuplicate) {
      alert((productLabel ? productLabel + " with " : "") + option.label + " already added.");
      return;
    }

    const row = { ...rows[idx] };
    row.unit = option;
    row.unit_price = option.total;
    rows[idx] = row;
    this.setState({
      rows
    }, () => {
      this.find_total(idx);
      setTimeout(() => {
        const $container = $(this.productRowRefs[idx]);
        if ($container.length) {
          const qtyInput = $container.find('.product_qty');
          if (qtyInput.length) {
            qtyInput.focus();
          }
        }
      }, 100);
    });

  }

  find_total(idx) {
    const rows = [...this.state.rows];
    const row = { ...rows[idx] };
    const qty = row.qty;
    const unit_price = row.unit_price;
    if (!unit_price) {
      return;
    }
    const total = qty * unit_price;
    row.total = parseFloat(total).toFixed(3);
    // console.log(total);
    rows[idx] = row;
    this.setState({
      rows
    });
    var grand_total = 0;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i]['total']) {
        grand_total += parseFloat(rows[i]['total']);
      }
    }
    this.setState({
      grand_total: parseFloat(grand_total).toFixed(3)
    });
  }

  handleChange = idx => e => {
    $(".single_product_container").css('background-color', '');
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    const row = { ...rows[idx] };
    row[name] = value;
    rows[idx] = row;
    var obj_this = this;
    this.setState({
      rows
    }, () => {
      if (e.target.name == "qty" || e.target.name == "unit_price") {
        obj_this.find_total(idx)
      }
    });
  };

  expandRowAndScroll(idx) {
    this.setState({ keyboardSpacerHeight: 350 });
    try {
      const $container = $(this.productRowRefs[idx]);
      const $maxBtn = $container.find('.maximize_button');
      if ($maxBtn && $maxBtn.is(':visible')) {
        $maxBtn.trigger('click');
      }
      setTimeout(() => {
        if (this.productRowRefs[idx]) {
          this.productRowRefs[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    } catch (_) {}
  }

  handleBlur() {
    setTimeout(() => {
      const activeEl = document.activeElement;
      if (!activeEl || !activeEl.closest('.single_product_container')) {
        this.setState({ keyboardSpacerHeight: 0 });
      }
    }, 150);
  }

  handleAddRow = () => {
    $(".single_product_container").css('background-color', '');
    if (!this.validateProducts(this.state.rows)) {
      return;
    }
    // console.log(this.state.rows);
    $(".single_product_container:not(:last-of-type) .minimize_button").trigger("click");
    const item = {
      product: {},
      unit_price: '',
      qty: "",
      unit: {}
    };
    this.setState({
      rows: [...this.state.rows, item]
    }, () => {
      setTimeout(() => {
        const lastIdx = this.state.rows.length - 1;
        if (this.productRowRefs[lastIdx]) {
          this.productRowRefs[lastIdx].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    // console.log(idx);
    // return;
    $(".single_product_container").css('background-color', '');
    const rows = [...this.state.rows];
    rows.splice(idx, 1);
    this.setState({
      rows
    });
    var grand_total = 0;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i]['total']) {
        grand_total += parseFloat(rows[i]['total']);
      }
    }
    this.setState({
      grand_total: parseFloat(grand_total).toFixed(3)
    });

  }

  formSubmit(e) {
    e.preventDefault();
    
    const returnorder = this.state;

    if(!returnorder.customer.value){
      this.customerSelect.current.focus();
      return;
    }
    if(!returnorder.return_type.value){
      this.return_typeSelect.current.focus();
      return
    }


    if (!this.validateProducts(returnorder.rows)) {
      return;
    }
    
    console.log(returnorder);
    // return;


    //product spec unique checking
    // if(returnorder.rows.length>1){
    //   var exist = 0;
    //   for(var i=0;i<returnorder.rows.length;i++){
    //     var product = returnorder.rows[i]['product']['value'];
    //     var specification = returnorder.rows[i]['specifications']?returnorder.rows[i]['specifications'].toUpperCase():"";
    //     for(var j=0;j<returnorder.rows.length;j++){
    //       if(i != j){
    //         var spec = returnorder.rows[j]['specifications']?returnorder.rows[j]['specifications'].toUpperCase():"";
    //         if(returnorder.rows[j]['product']['value'] == product && spec == specification){
    //           // $(".single_product_container").find(".minimize_button").trigger("click");
    //           $(".single_product_container[index="+i+"], .single_product_container[index="+j+"]").find(".maximize_button").trigger("click");
    //           $(".single_product_container[index="+i+"], .single_product_container[index="+j+"]").css('background-color','#ff000063');
    //           exist = 1;
    //           // break;
    //         }
    //       }
    //     }
    //   }
    //   if(exist){
    //     alert("Products with similar specification exists.");
    //     return false;
    //   }
    // }


    delete returnorder.customers;
    delete returnorder.return_types;
    delete returnorder.products;
    returnorder.sid=this.context.user_details.sid;
    var fd = new FormData(document.querySelector('form'));
    fd.append('sid',this.context.user_details.sid);
    fd.append('customer_id',this.state.customer.value);
    fd.append('new_img',this.state.compress_image);
    fd.append('file_delete',this.state.fileDeleted);
    //fd.delete(this.state.image);
    

    for (let i = 0; i < this.state.rows.length; i++) {
      fd.append("product[]", this.state.rows[i]['product']['value']);
      fd.append("qty[]", this.state.rows[i]['qty']);
      fd.append("unit[]", this.state.rows[i]['unit']['value']);
      fd.append("unit_price[]", this.state.rows[i]['unit_price']);
      fd.append("total[]", this.state.rows[i]['total']);

    }
    //fd.append('image', this.state.image)

    fd.append('salesreturn_id',this.state.salesreturn_id);
    fd.append('return_type',this.state.return_type.value);
    fd.append('grand_total',this.state.grand_total);

    const url = `${process.env.REACT_APP_SSS}/api/saveSalesReturn`;
    this.context.loading(1);
    var obj_this = this;
    axios.post(url, fd)
      .then(return_data => {
        console.log(return_data);
        if (return_data.data.status == "insert") {
          alert("Sales Return Order successfully inserted");
        } else if (return_data.data.status == "update") {
          alert("Sales Return successfully updated");
        } else {
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
          return;
        }
        obj_this.props.history.goBack();
        obj_this.context.loading(0);
      })
      .catch(err => {
        console.error(err);
        alert("Network or Server error occurred");
        obj_this.context.loading(0);
      });
  }


  validateProducts(products) {
    if (!products || products.length === 0) {
      alert("Please add at least one product");
      return false;
    }
    for (var i = 0; i < products.length; i++) {
      if (!products[i].product || !products[i].product.label) {
        alert("Choose product in row " + (i + 1));
        $(".single_product_container[index=" + i + "]").find(".maximize_button").trigger("click");
        $(".single_product_container[index=" + i + "]").find(".product").focus();
        return false;
      }
      if (!products[i].qty || parseFloat(products[i].qty) <= 0) {
        alert("Quantity required in row " + (i + 1));
        $(".single_product_container[index=" + i + "]").find(".maximize_button").trigger("click");
        $(".single_product_container[index=" + i + "]").find(".product_qty").focus();
        return false;
      }
      if (!products[i].unit_price || parseFloat(products[i].unit_price) < 0) {
        alert("Unit price required in row " + (i + 1));
        $(".single_product_container[index=" + i + "]").find(".maximize_button").trigger("click");
        $(".single_product_container[index=" + i + "]").find(".unit_price").focus();
        return false;
      }
      if (!products[i].unit || !products[i].unit.label) {
        alert("Choose unit in row " + (i + 1));
        $(".single_product_container[index=" + i + "]").find(".maximize_button").trigger("click");
        $(".single_product_container[index=" + i + "]").find(".unit").focus();
        return false;
      }
    }
    return true;
  }
  uploadImage = (e) => {
    this.setState({
      fileDeleted :0
    });
    if (e.target.files && e.target.files[0]) {
      this.setState({
        file: URL.createObjectURL(e.target.files[0])
      });
    }

    this.setState({
      image: e.target.files[0]
    })
    var new_img = e.target.files[0];
    const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          initialQuality: 0.85,
        };
        if (options.maxSizeMB >= new_img / 1024) {  
    return;
     }

    let output;
    
    imageCompression(new_img, options).then((x) => {
    output = x;
    this.setState({
     compress_image: output
     })
    //console.log(output);
  });
    var n = document.getElementsByClassName('ret_img');
    var n1 = document.getElementsByClassName('close');

    $(n).css({
      'display': 'inline-block'
    });

    $(n1).css({
      'display': 'inline-block'
    });
    console.log(this.state.file);
  }
  getComponent(e) {
    this.setState({
      fileDeleted :1
    });
    var name = e.target.getAttribute('name');
    if (name) {
      $(e.target).css({
        'display': 'none'
      });
      var n = document.getElementsByClassName('ret_img');
      $(n).css({
        'display': 'none'
      });
      this.setState({
        return_image: '',
        file  : ''
      })
    }
    else {
      var n = document.getElementsByClassName('ret_img');
      $(e.target).css({
        'display': 'none'
      });
      $(n).css({
        'display': 'none'
      });
      this.setState({
        image: '',
        file: ''
      })
    }

  }

  render() {
    this.productRowRefs = [];

    const {  isOpen } = this.state;
    return (
      <MyContext.Consumer>
        {context => (
          <div className="new_returnorder_container">
            <div className="page_header">
              
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.salesreturn_id ? "Edit" : "New"} Sales Return order</div>
            </div>
            <form className="sales_order_form"
              onSubmit={e => this.formSubmit(e) } encType="multipart/form-data" 
            >
              <div className="customer_details_container blocks">
                <div className="input_label">Customer</div>
                <Select
                  options={this.state.customers}
                  value={this.state.customer}
                  className="customer"
                  ref={this.customerSelect}
                  onChange={e => this.customerChange(e)}
                  required
                isDisabled = {this.state.salesreturn_id?true:""}
                />
                <div className="input_label">Return Type</div>
                <Select
                  options={this.state.return_types}
                  value={this.state.return_type}
                  className="return_type"
                  ref={this.return_typeSelect}
                  onChange={e => this.ReturnTypeChange(e)}
                  required
                />

                <div className="input_label">Return Reason</div>
                <textarea className="input remarks custom_input"
                  name="return_reason"
                  value={this.state.return_reason}
                  onChange={e => this.formChange(e)}
                  autoComplete="off"
                  required
                />
              </div>
              <div className="products_container blocks">
                <div className="subtitle"
                  style={{ display: "inline-block" }}
                >
                  <i className="fa fa-shopping-cart"></i>
                  Products
                </div>
                {this.state.rows.map((item, idx) => (
                  <div className="single_product_container" key={idx} index={idx} ref={el => this.productRowRefs[idx] = el} onBlur={this.handleBlur}>
                    <div className="product_label_and_delete_button">
                      <div className="maximize_button">
                        <i className="fa fa-plus"></i>
                      </div>
                      <div className="minimize_button">
                        <i className="fa fa-minus"></i>
                      </div>
                      <div className="product_label">
                        {item.product.label}
                      </div>
                      <i className="delete_product_button fa fa-trash-alt"
                        type="button"
                        style={{ visibility: this.state.rows? this.state.rows.length-1>0? "visible" : "hidden" :"hidden" }}
                        onClick={this.handleRemoveSpecificRow(idx)}
                      ></i>
                    </div>
                    <div className="qty_unit_price_container">
                      <span
                        style={{ visibility: item.unit.label ? "visible" : "hidden" }}
                      >Qty : {item.qty} {item.unit.label}</span>
                      <span
                        style={{ visibility: item.unit_price ? "visible" : "hidden" }}
                      >Unit Price : {item.unit_price}</span>
                      <div
                        style={{ visibility: item.total ? "visible" : "hidden" }}
                        className="product_total"
                      >Price: {this.context.currency}.
                        {/* <span>{parseFloat(item.qty*item.unit_price).toFixed(2)}</span> */}
                        <span>{item.total}</span>
                      </div>
                    </div>
                    <div className="input_label">Product</div>
                    <Select
                      options={this.state.products}
                      value={item.product}
                      className="product"
                      onChange={e => this.productChange(e, idx)}
                      required
                      onFocus={() => this.expandRowAndScroll(idx)}
                      onMenuOpen={() => this.expandRowAndScroll(idx)}
                      openMenuOnFocus
                    />

                    <div className="">
                      {/* <div>
                        <div className="input_label">Specifications</div>
                        <input className="input specifications custom_input"
                          type="text"
                          name="specifications"
                          value={item.specifications}
                          onChange={this.handleChange(idx)}
                          autoComplete="off"
                        />
                      </div> */}
                      <div>
                        <div className="input_label">Unit</div>
                        <Select
                          options={item.units}
                          value={item.unit}
                          placeholder=""
                          className="unit"
                          onChange={e => this.unitChange(e, idx)}
                          required
                          onFocus={() => this.expandRowAndScroll(idx)}
                          onMenuOpen={() => this.expandRowAndScroll(idx)}
                          openMenuOnFocus
                        />
                      </div>
                    </div>

                    <div className="input_grid">
                      <div>
                        <div className="input_label">Quantity</div>
                        <input className="product_qty custom_input"
                          type="number"
                          name="qty"
                          step="0.001"
                          min="0"
                          value={item.qty}
                          onChange={this.handleChange(idx)}
                          onFocus={() => this.expandRowAndScroll(idx)}
                          autoComplete="off"
                        />
                      </div>
                      <div>
                        <div className="input_label">Unit Price</div>
                        <input className="unit_price input custom_input"
                          type="number"
                          name="unit_price"
                          value={item.unit_price}
                          onChange={this.handleChange(idx)}
                          onFocus={() => this.expandRowAndScroll(idx)}
                          min="0"
                          step="0.001"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="price_and_add_button_container">
                  <div className="grand_total"
                    style={{ visibility: this.state.grand_total ? "visible" : "hidden" }}
                  >Total ({this.state.rows.length}) {this.context.currency}.
                    <b> {this.state.grand_total}</b>
                  </div>
                  <button className="add_product_button"
                    type="button"
                    // style={{ visibility: this.state.rows[this.state.rows.length - 1].product.label && this.state.rows[this.state.rows.length - 1].unit.label ? "visible" : "hidden" }}
                    onClick={this.handleAddRow}
                  >
                    <i className="fa fa-plus"></i> Product
                  </button>
                </div>
                {this.state.salesreturn_id ?
                  <span>
                  {this.state.return_image ?
                    <span className="form-group multi-preview" style={{ marginTop: '10px' }} style={{ display: this.state.return_image ? "block" : "none" }}>


                      <span className="thumbnail">

                        <img src={`${this.url}/${this.state.return_image}`} onClick={() => this.setState({ isOpen: true })} alt="no image" className="ret_img" name="ret_img" />
                        <a>  <i className="close far fa-times-circle" name="iclose" onClick={(e) => this.getComponent(e)} > </i></a>

                      </span>

                      <span className="ril__builtinButton">

                      {isOpen && (
                        <Lightbox
                          mainSrc={`${this.url}/${this.state.return_image}`}                         
                          onCloseRequest={() => this.setState({ isOpen: false })}                         
                        />
                      )}

                      </span>


                    </span>:
                    <span className="form-group multi-preview" style={{ marginTop: '10px' }} style={{ display: this.state.file ? "block" : "none" }}>


                      <span className="thumbnail">

                        <img src={this.state.file} onClick={() => this.setState({ isOpen: true })} alt="no image" className="ret_img" />
                        <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e)} > </i></a>

                      </span>

                      <span className="ril__builtinButton"> 

                      {isOpen && (
                        <Lightbox
                          mainSrc={this.state.file}                         
                          onCloseRequest={() => this.setState({ isOpen: false })}
                        />
                      )}

                      </span>

                    </span>
                  }
                  </span>
                  :


                  <span className="form-group multi-preview" style={{ marginTop: '10px' }} style={{ display: this.state.file ? "block" : "none" }}>


                    <span className="thumbnail">

                      <img src={this.state.file} className="ret_img"  onClick={() => this.setState({ isOpen: true })}   alt="no image" />
                      <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e)} > </i></a>

                    </span> 

                    <span className="ril__builtinButton"> 

                      {isOpen && (
                        <Lightbox
                          mainSrc={this.state.file}                       
                          onCloseRequest={() => this.setState({ isOpen: false })}                  
                        />
                      )}
                      
                    </span>

                  </span>

                }

                {/* <div className="input_label">Upload Photo</div>
                <input className="file_upload"
                  type="file"
                  name="image"
                  id="files"
                  onChange={this.uploadImage}
                  autoComplete="off"
                  disabled={this.state.image || this.state.return_image}

                /> */}

              </div>
              <div style={{ height: this.state.keyboardSpacerHeight, transition: 'height 0.2s ease-out' }}></div>
              <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
            </form>
          </div>
        )}
      </MyContext.Consumer>
    )
  }
}

export default NewReturnOrder;
NewReturnOrder.contextType = MyContext;
